import { adapterType } from "../create-app-page-templates";
import { optionsType } from "../Components/create-app-page-app-type-dropdown";
import APPTYPES from "../services/create-app-page-app-types.const.json";
import licenseService from "../../../../../../core/services/metaStoreService/license-service";
import { fetchLabelBasedOnLicense } from "../Components/adapter-selection/app-types-info";
import ILCDCSupportedAdapters from "../../../../../../resources/ILCDCSupportedAdapters.json";
import commonAdapterNameService from "../../../../../../core/services/componentService/common-adapter-name-service";
import { createAppUtils } from "../create-app-page-utils";
import { componentID } from "../../../../../../core/services/componentService/component-service";
import templateInfoService from "../../../../../../core/services/componentService/topology-info-service";

export const getSupportedAppType = (sourceAdapter: adapterType, targetAdapter: adapterType): optionsType[] | null => {
    let supportedAppType: optionsType[] = [];
    try {
        let ilComponentID: componentID | undefined;
        let cdcComponentID: componentID | undefined;
        if (commonAdapterNameService.getCommonNames()?.includes(sourceAdapter.adapter)) {
            ilComponentID = commonAdapterNameService.getILComponentName(sourceAdapter.adapter);
            cdcComponentID = commonAdapterNameService.getCDCComponentName(sourceAdapter.adapter);
        }
        const sourceComponentName = sourceAdapter.adapter;
        const TargetComponentName = targetAdapter.adapter;
        const ILCDCSourceComponentName =
            commonAdapterNameService.getComponentName(sourceComponentName, APPTYPES.AUTOMATEDILCDC) ||
            sourceComponentName;

        const label = fetchLabelBasedOnLicense(licenseService?.nonSegmentedlicenseName, targetAdapter?.adapter);

        const isSourceAppAdapter = createAppUtils.isSourceAppAdapter(sourceComponentName);
        const isILCDCSupported =
            ILCDCSupportedAdapters.sources.includes(ILCDCSourceComponentName) &&
            ILCDCSupportedAdapters.targets.includes(TargetComponentName);

        const addAppTypeIfSupported = (condition, appType, isEnabled = true) => {
            if (condition) {
                supportedAppType.push({
                    label: label[appType],
                    value: appType,
                    isEnabled
                });
            }
        };

        const isILLicensed = sourceAdapter.ilModeInfo?.isEnabled ?? true;
        const isCDCLicensed = sourceAdapter.cdcModeInfo?.isEnabled ?? true;

        // Automated (IL + CDC) requires both the IL and CDC adapters to be licensed to be enabled.
        addAppTypeIfSupported(isILCDCSupported, APPTYPES.AUTOMATEDILCDC, isILLicensed && isCDCLicensed);

        if (!isILCDCSupported) {
            addAppTypeIfSupported(
                isSourceAppAdapter && sourceComponentName !== "SalesforceCDCReader",
                APPTYPES.AUTOMATEDMODE
            );
        }

        sourceAdapter?.modes?.forEach(appType => {
            // If the source is clubbed adapter, check for IL and CDC support
            if (ilComponentID && cdcComponentID) {
                if (appType === APPTYPES.IL) {
                    const isILSupported = !templateInfoService.isTopologyUnSupported(
                        ilComponentID,
                        TargetComponentName
                    );
                    addAppTypeIfSupported(isILSupported, appType, isILLicensed);
                    return;
                }
                if (appType === APPTYPES.CDC) {
                    const isCDCSupported = !templateInfoService.isTopologyUnSupported(
                        cdcComponentID,
                        TargetComponentName
                    );
                    addAppTypeIfSupported(isCDCSupported, appType, isCDCLicensed);
                    return;
                }
            }
            // If the source is not clubbed adapter, add the app type
            addAppTypeIfSupported(true, appType);
        });

        return supportedAppType.length ? supportedAppType : null;
    } catch (error) {
        console.log(error);
        return null;
    }
};
